import { render, staticRenderFns } from "./MetalPendant.vue?vue&type=template&id=1f446d3a&scoped=true&"
import script from "./MetalPendant.vue?vue&type=script&lang=js&"
export * from "./MetalPendant.vue?vue&type=script&lang=js&"
import style0 from "./MetalPendant.vue?vue&type=style&index=0&id=1f446d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f446d3a",
  null
  
)

component.options.__file = "MetalPendant.vue"
export default component.exports